module.exports = __webpack_public_path__ + "img/a1737d5.png";